import React, { lazy } from 'react';
import { Lock, Zap, ShieldCheck, CheckCircle2 } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function ProductPresentation() {
  return <section className="bg-brand-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-287">
      <div className="max-w-6xl mx-auto" data-id="element-288">
        <div className="text-center mb-16" data-id="element-289">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-dark" data-id="element-290">
            Lo que obtienes cuando empiezas hoy
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12" data-id="element-291">
          {/* Main Product Card */}
          <div className="lg:col-span-12 bg-white rounded-2xl border-2 border-brand-gold shadow-xl overflow-hidden flex flex-col md:flex-row" data-id="element-292">
            <div className="md:w-1/2 p-8 flex items-center justify-center bg-brand-dark/5" data-id="element-293">
              <img src="https://cdn.magicpatterns.com/uploads/tJbPjAGTwuLr3gh2PY2nnk/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).webp" alt="El Reinicio Biológico" width="400" height="400" loading="lazy" decoding="async" className="max-w-full h-auto drop-shadow-lg" data-id="element-294" />
            </div>
            <div className="md:w-1/2 p-8 sm:p-12 flex flex-col justify-center" data-id="element-295">
              <div className="inline-block bg-brand-gold text-brand-dark font-bold px-4 py-1 rounded-full text-sm mb-6 self-start" data-id="element-296">
                Valor: 97€
              </div>
              <h3 className="text-2xl sm:text-3xl font-serif font-bold text-brand-dark mb-2" data-id="element-297">
                El Reinicio Biológico — El Protocolo Principal
              </h3>
              <h4 className="text-lg font-bold text-green-700 mb-6 uppercase tracking-wide" data-id="element-298">
                Tu manual de batalla de 14 días
              </h4>
              <p className="text-brand-gray text-lg leading-relaxed" data-id="element-299">
                El sistema técnico completo. Día a día, comida a comida,
                decisión a decisión. Sin improvisación. Sin confusión. Con el
                orden exacto para que tu biología responda.
              </p>
            </div>
          </div>

          {/* Bonus 1 */}
          <div className="lg:col-span-6 bg-white rounded-2xl border border-brand-gold/50 shadow-md overflow-hidden flex flex-col sm:flex-row" data-id="element-300">
            <div className="sm:w-2/5 p-6 flex items-center justify-center bg-gray-50 hidden sm:flex" data-id="element-301">
              <img src="https://cdn.magicpatterns.com/uploads/58ZmqCVURjSt12Ttx3rpqw/BONO_1_(1)_(1).webp" alt="Hoja de Ruta Diaria" width="200" height="200" loading="lazy" decoding="async" className="max-w-full h-auto drop-shadow" data-id="element-302" />
            </div>
            <div className="sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-303">
              <div className="inline-block bg-brand-gold/20 text-brand-dark font-bold px-3 py-1 rounded-full text-xs mb-3 self-start" data-id="element-304">
                Valor: 27€
              </div>
              <h4 className="text-xl font-bold text-brand-dark mb-3" data-id="element-305">
                BONO 1: Hoja de Ruta Diaria
              </h4>
              <p className="text-brand-gray text-sm" data-id="element-306">
                Tu guía visual día a día. Sabes exactamente qué hacer cada
                mañana cuando abres los ojos. Cero dudas. Máxima claridad.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="lg:col-span-6 bg-white rounded-2xl border border-brand-gold/50 shadow-md overflow-hidden flex flex-col sm:flex-row" data-id="element-307">
            <div className="sm:w-2/5 p-6 flex items-center justify-center bg-gray-50 hidden sm:flex" data-id="element-308">
              <img src="https://cdn.magicpatterns.com/uploads/9uP7trk1YZPPkV6G1bM9Tm/BONO_2_(1)_(1).webp" alt="Recetario Express" width="200" height="200" loading="lazy" decoding="async" className="max-w-full h-auto drop-shadow" data-id="element-309" />
            </div>
            <div className="sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-310">
              <div className="inline-block bg-brand-gold/20 text-brand-dark font-bold px-3 py-1 rounded-full text-xs mb-3 self-start" data-id="element-311">
                Valor: 47€
              </div>
              <h4 className="text-xl font-bold text-brand-dark mb-3" data-id="element-312">
                BONO 2: Recetario Express
              </h4>
              <p className="text-brand-gray text-sm" data-id="element-313">
                31 recetas antiinflamatorias de menos de 10 minutos. Diseñadas
                para España: ingredientes del Mercadona, sabores que conoces,
                resultados que no conocías.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="lg:col-span-6 bg-white rounded-2xl border border-brand-gold/50 shadow-md overflow-hidden flex flex-col sm:flex-row" data-id="element-314">
            <div className="sm:w-2/5 p-6 flex items-center justify-center bg-gray-50 hidden sm:flex" data-id="element-315">
              <img src="https://cdn.magicpatterns.com/uploads/skcpdBqRvwkHvXxwcdQiW7/BONO_3_(2).webp" alt="Saboteadores Ocultos" width="200" height="200" loading="lazy" decoding="async" className="max-w-full h-auto drop-shadow" data-id="element-316" />
            </div>
            <div className="sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-317">
              <div className="inline-block bg-brand-gold/20 text-brand-dark font-bold px-3 py-1 rounded-full text-xs mb-3 self-start" data-id="element-318">
                Valor: 17€
              </div>
              <h4 className="text-xl font-bold text-brand-dark mb-3" data-id="element-319">
                BONO 3: Saboteadores Ocultos
              </h4>
              <p className="text-brand-gray text-sm" data-id="element-320">
                Los 23 ingredientes que están en tu despensa ahora mismo
                disparando tu inflamación. Muchos tienen fama de 'saludables'.
              </p>
            </div>
          </div>

          {/* Bonus 4 */}
          <div className="lg:col-span-6 bg-white rounded-2xl border border-brand-gold/50 shadow-md overflow-hidden flex flex-col sm:flex-row" data-id="element-321">
            <div className="sm:w-2/5 p-6 flex items-center justify-center bg-gray-50 hidden sm:flex" data-id="element-322">
              <img src="https://cdn.magicpatterns.com/uploads/v14VKsfF6dTw72uEYNmock/BONO_4_(1)_(1).webp" alt="Lista de Compras" width="200" height="200" loading="lazy" decoding="async" className="max-w-full h-auto drop-shadow" data-id="element-323" />
            </div>
            <div className="sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-324">
              <div className="inline-block bg-brand-gold/20 text-brand-dark font-bold px-3 py-1 rounded-full text-xs mb-3 self-start" data-id="element-325">
                Valor: 17€
              </div>
              <h4 className="text-xl font-bold text-brand-dark mb-3" data-id="element-326">
                BONO 4: Lista de Compras Inteligente
              </h4>
              <p className="text-brand-gray text-sm" data-id="element-327">
                Tu inventario exacto para empezar mañana. Sin buscar, sin
                improvisar, sin excusas.
              </p>
            </div>
          </div>
        </div>

        {/* Value Summary Box */}
        <div className="max-w-3xl mx-auto bg-brand-dark text-white rounded-3xl p-8 sm:p-12 text-center shadow-2xl border border-brand-gold/30" data-id="element-328">
          <div className="mb-6" data-id="element-329">
            <span className="text-gray-400 text-lg" data-id="element-330">Valor total: </span>
            <span className="text-gray-400 text-xl line-through decoration-brand-red decoration-2" data-id="element-331">
              205€
            </span>
          </div>

          <div className="mb-8" data-id="element-332">
            <span className="text-2xl sm:text-3xl font-bold text-white" data-id="element-333">
              TU INVERSIÓN HOY:{' '}
            </span>
            <span className="text-4xl sm:text-5xl font-bold text-brand-gold" data-id="element-334">
              26€
            </span>
            <span className="text-sm text-gray-400 block mt-2" data-id="element-335">
              (IVA incluido)
            </span>
          </div>

          <a href="https://pay.hotmart.com/W104988940M?off=y9azogt4&checkoutMode=10&bid=1774913274137" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full bg-brand-gold text-brand-dark font-bold text-xl sm:text-2xl py-5 px-8 rounded-full hover:bg-yellow-500 transition-colors shadow-lg mb-6 min-h-[56px] flex items-center justify-center" data-id="element-336">
            SÍ, QUIERO MI REINICIO BIOLÓGICO — 26€
          </a>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-sm text-gray-300 font-medium" data-id="element-337">
            <div className="flex items-center" data-id="element-338">
              <Zap className="w-4 h-4 mr-2 text-brand-gold" data-id="element-339" />
              <span data-id="element-340">Acceso inmediato</span>
            </div>
            <div className="flex items-center" data-id="element-341">
              <Lock className="w-4 h-4 mr-2 text-brand-gold" data-id="element-342" />
              <span data-id="element-343">Pago 100% seguro</span>
            </div>
            <div className="flex items-center" data-id="element-344">
              <CheckCircle2 className="w-4 h-4 mr-2 text-brand-gold" data-id="element-345" />
              <span data-id="element-346">Garantía 15 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}